<template>
  <div class="main-container">
    <!-- 添加编辑 -->
    <el-dialog
      :title="editType == 1 ? '添加' : '编辑'"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        ref="editForm"
        :rules="editRules"
      >
        <el-row v-if="editType != 1">
          <el-form-item
            label="模板编码"
            prop="ProtocolID"
          >
            <el-input
              v-model="editForm.ProtocolCode"
              autocomplete="off"
              disabled
              placeholder="请输入模板编码"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="公司名称"
            prop="CompID"
          >
            <el-select
              style="width:100%;"
              v-model="editForm.CompID"
              placeholder="请选择"
            >
              <el-option
                v-for="item in CompanyList"
                :key="item.CompValue"
                :label="item.CompName"
                :value="item.CompID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="型号编码"
            prop="ProtocolModel"
          >
            <el-input
              v-model="editForm.ProtocolModel"
              autocomplete="off"
              placeholder="请输入型号编码"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="协议类型"
            prop="ProtocolType"
            class="formItem"
          >
            <el-select
              style="width:100%;"
              v-model="editForm.ProtocolType"
              placeholder="请选择协议类型"
            >
              <el-option
                v-for="item in dictOptions"
                :key="item.DicValue"
                :label="item.DicName"
                :value="item.DicID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="规格标识"
            class="formItem"
            prop="ProtocolSpec"
          >
            <el-select
              style="width:100%;"
              v-model="editForm.ProtocolSpec"
              placeholder="请选择规格标识"
            >
              <el-option
                v-for="item in Spec"
                :key="item.DicValue"
                :label="item.DicName"
                :value="item.DicID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="模板名称">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入模板名称"
              v-model="editForm.ProtocolName"
              resize="none"
            >
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="适用型号">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入适用型号"
              v-model="editForm.ProductUse"
              resize="none"
            >
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="备注说明">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入备注说明"
              v-model="editForm.Remark"
              resize="none"
            >
            </el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="editForm.Status == 1"
          @click="backout(editForm.ProtocolID)"
        >撤销审核</el-button>
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('editForm')"
          :loading="sumbitLoading"
          :disabled="editForm.Status == 1"
        >确 定</el-button>
      </div>
    </el-dialog>
    <div class="toolBox">
      <div class="leftBox">
        <el-form
          :inline="true"
          :model="searchForm"
          class="searchForm"
          size="mini"
        >
          <el-form-item
            label="模板信息"
            style="margin-bottom: 0"
          >
            <el-input
              v-model="searchForm.ProtocolCode"
              placeholder="请输入模板信息"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="公司名称"
            style="margin-bottom: 0"
          >
            <el-input
              v-model="searchForm.CompName"
              placeholder="请输入公司名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="适用型号"
            style="margin-bottom: 0"
          >
            <el-input
              v-model="searchForm.ProductUse"
              placeholder="请输入适用型号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="状态"
            style="margin-bottom: 0"
          >
            <el-select
              v-model="searchType"
              placeholder="请选择状态"
              style="width: 120px"
              clearable
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-button
              type="primary"
              @click="search"
            >查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="rightBox">
        <el-button
          icon="el-icon-plus"
          @click="add"
           size="mini"
        >添加</el-button>
        <excel-export
          :sheet="sheet"
          filename="模板管理"
          ref="excelExport"
          :manual="true"
          style="margin: 0 10px"
        >
          <el-button
            icon="el-icon-upload2"
            type="success"
             size="mini"
            @click="getList(searchForm, true)"
            :loading="exportLoading"
          >导出</el-button>
        </excel-export>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="table.data"
        border
        height="100%"
        stripe
        size="mini"
        style="width: 100%"
        :header-cell-style="{ background: '#2c86d1', color: 'white',textAlign:'center' }"
        :cell-style="{textAlign:'center'}"
        v-loading="table.loading"
      >
        <el-table-column
          fixed
          prop="ProtocolCode"
          label="模板编码"
          width="200"
        > </el-table-column>
        <el-table-column
          fixed
          prop="ProtocolName"
          label="模板名称"
          width="150"
        > </el-table-column>
        <el-table-column
          fixed
          prop="Status"
          label="状态"
        >
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.Status===0 || scope.row.Status===null"
              type="danger"
            >待审核</el-tag>
            <el-tag v-if="scope.row.Status===1">已审核</el-tag>
            <el-tag
              v-if="scope.row.Status===2"
              type="success"
            >正式使用</el-tag>

          </template>
        </el-table-column>
        <el-table-column
          prop="CompName"
          label="公司名称"
          width="200"
          :show-overflow-tooltip="true"
        > </el-table-column>
        <el-table-column
          prop="ProtocolModel"
          label="型号编码"
        > </el-table-column>
        <el-table-column
          prop="ProtocolType"
          label="协议类型"
          width="90"
        >
          <template slot-scope="scope">
            <p v-if="scope.row.ProtocolType === 'M'">Modbus</p>
            <p v-if="scope.row.ProtocolType === 'D'">DLT</p>
            <p v-if="scope.row.ProtocolType === 'C'">CJT</p>

          </template>
        </el-table-column>
        <el-table-column
          prop="ProtocolSpec"
          label="规格标识"
          width="120"
        >
          <template slot-scope="scope">
            <p v-if="scope.row.ProtocolSpec === 'Mini'">精简采集模板</p>
            <p v-if="scope.row.ProtocolSpec === 'Std'">标准采集模板</p>
            <p v-if="scope.row.ProtocolSpec === 'Full'">全功能采集模板</p>
            <p v-if="scope.row.ProtocolSpec === 'Cus'">自定义采集模板</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="ProductUse"
          label="适用型号"
        > </el-table-column>
        <el-table-column
          prop="Remark"
          label="备注说明"
          width="160"
        > </el-table-column>
        <el-table-column
          prop="CreateUserName"
          label="创建人"
        > </el-table-column>
        <el-table-column
          prop="CreateTime"
          label="创建时间"
          width="160"
        > </el-table-column>
        <el-table-column
          prop="UpdateTime"
          label="修改时间"
          width="160"
        > </el-table-column>
        <el-table-column
          prop="CheckUserName"
          label="审核人"
        > </el-table-column>
        <el-table-column
          prop="CheckTime"
          label="审核时间"
          width="160"
        > </el-table-column>

        <!-- <el-table-column prop="Remark" label="联系电话"> </el-table-column> -->

        <el-table-column
          fixed="right"
          label="操作"
          width="330"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="edit(scope.row)"
              v-if="scope.row.Status !== 2"
            >编辑</el-button>
            <el-popconfirm
              :title="`确认删除模板「${scope.row.ProtocolCode}」吗`"
              style="margin: 0 10px"
              @confirm="del(scope.row.ProtocolID)"
            >
              <el-button
                slot="reference"
                size="mini"
                type="danger"
                v-if="scope.row.Status == 0"
              >删除</el-button>
            </el-popconfirm>
            <el-button
              size="mini"
              type="warning"
              @click="handleConfig(scope.row)"
            >配置协议</el-button>
            <el-popconfirm
              :title="`确认审核「${scope.row.ProtocolCode}」吗`"
              style="margin: 0px 0px 0px 10px"
              @confirm="Check(scope.row.ProtocolID)"
            >
              <el-button
                slot="reference"
                size="mini"
                type="primary"
                :disabled="scope.row.Status== 1"
                v-if="scope.row.Status == 0"
              >审核</el-button>
              <el-button
                slot="reference"
                size="mini"
                type="success"
                v-if="scope.row.Status == 1"
              >正式使用</el-button>

            </el-popconfirm>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="listPage admin_page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="table.pageNum"
        :page-sizes="[15, 30, 45]"
        :page-size="table.pageSize"
        layout="total,prev, pager, next, sizes, jumper"
        :total="table.total"
        background
      >
      </el-pagination>
    </div>
    <!-- 配置协议 -->
    <el-dialog
      :title="modalTitle"
      :visible.sync="configFlag"
      top="6vh"
      width="95%"
      :close-on-click-modal="false"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="遥测点表"
          name="second"
        >
          <Telemetry
            :item="TempVerID"
            :power="power"
            :Value="Value"
            :key="activeName"
          />
        </el-tab-pane>
        <el-tab-pane
          label="遥信点表"
          name="first"
        >
          <Remote
            :item="TempVerID"
            :power="power"
            :Value="Value"
            :key="activeName"
          />
          <!-- <Remote
            :item="TempVerID"
            :IsAdd="power.IsAdd"
            :IsEdit="power.IsEdit"
            :IsDelete="power.IsDelete"
          /> -->
        </el-tab-pane>
        <el-tab-pane
          label="遥控点表"
          name="three"
        >
          <Telecontrol
            :item="TempVerID"
            :power="power"
            :Value="Value"
            :key="activeName"
          />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { ExcelExport } from "pikaz-excel-js";
import { mapGetters } from "vuex";
import Telemetry from "./component/Telemetry";
import Remote from "./component/remote";
import Telecontrol from "./component/telecontrol";
export default {
  components: {
    ExcelExport,
    Telemetry,
    Remote,
    Telecontrol,
  },
  data() {
    return {
      exportLoading: false,
      //导出集合
      exportList: [],
      //导出数据:
      sheet: [],
      sumbitLoading: false,
      modalTitle: "", //配置协议
      table: {
        data: [],
        loading: false,
        pageSize: 15, //每页显示条数
        pageNum: 1, //当前页数
        total: 0, //总条数
      },
      searchForm: {
        ProtocolCode: null,
        CompName: null,
        ProductUse: null,
        Status: null,
      },
      editType: 1, //1添加2编辑
      editFormVisible: false,
      editForm: {},
      editRules: {
        CompID: [
          {
            required: true,
            message: "请选择公司名称",
            trigger: "change",
          },
        ],
        ProtocolModel: [
          {
            required: true,
            message: "请输入型号编码",
            trigger: "change",
          },
        ],
        ProtocolType: [
          {
            required: true,
            message: "请选择协议类型",
            trigger: "change",
          },
        ],
        ProtocolSpec: [
          {
            required: true,
            message: "请选择规格标识",
            trigger: "change",
          },
        ],
      },
      searchType: "",
      statusOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "待审核",
        },
        {
          value: 1,
          label: "已审核",
        },
        {
          value: 2,
          label: "正式使用",
        },
      ],
      TempVerID: "",
      CompanyList: [], //公司列表
      dictOptions: [], //获取数据字典
      Spec: [], //规格标识
      modalTitle: "",
      modalFlag: false,
      configFlag: false,
      loading: true,
      placeholder: "请输入",
      activeName: "second",
      form: {
        VerNo: "",
        VerName: "",
        VerDesc: "",
        OrderNo: "",
        VerIndex: "",
      },
      list: [],
      power: "",
      Value: {
        SessionId: "",
        UserId: "",
        ClientName: "Hoko.Iot.Web.",
      },
      // power: {
      //   IsAdd: this.IsAdd,
      //   IsEdit: this.IsEdit,
      //   IsDelete: this.IsDelete,
      // },
    };
  },
  computed: {
    ...mapGetters(["SessionId", "UserId"]),
  },

  mounted() {
    this.getDict("025");
    this.getDict1("024");
    this.getList();
    this.Company();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "editForm") {
            this.sumbit();
          }
        } else {
          return false;
        }
      });
    },
    // 撤销
    backout(ProtocolID) {
      this.$messageBox
        .confirm("确认撤销当前项?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          this.CheckCancel(ProtocolID);
        })
        .catch(() => {});
    },
    async CheckCancel(ProtocolID) {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          ProtocolID,
        },
      };
      const res = await this.$api.axios_http(
        this.$gd.admin.template.CheckCancel,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        this.$message.success("撤销成功");
        this.editFormVisible = false;
        this.getList(this.searchForm);
      } else {
        this.$message.error(res.Error);
      }
    },
    //翻页事件
    handleSizeChange(val) {
      this.table.pageSize = val;
      this.getList(this.searchForm, this.searchType);
    },
    //翻页事件
    handleCurrentChange(val) {
      this.table.pageNum = val;
      this.getList(this.searchForm, this.searchType);
    },
    // 添加
    add() {
      this.reset();
      this.editType = 1;
      this.editFormVisible = true;
    },
    edit(data) {
      //编辑
      this.reset();
      this.editForm = JSON.parse(JSON.stringify(data));
      this.editType = 2;
      this.editFormVisible = true;
    },
    // 点表配置
    handleConfig(item) {
      this.modalTitle = "点表配置";
      this.configFlag = true;
      this.Value.SessionId = this.SessionId;
      this.Value.UserId = this.UserId;
      // 传给子界面的参数
      this.TempVerID = item.ProtocolID;
      this.power = item.Status;
    },
    // 表单重置
    reset() {
      this.editForm = {
        CompID: null,
        ProtocolModel: null,
        ProtocolType: null,
        ProtocolSpec: null,
        ProtocolName: null,
        ProductUse: null,
        Remark: null,
      };
      if (this.$refs["editForm"]) {
        this.$refs["editForm"].resetFields();
      }
    },
    search() {
      this.table.pageNum = 1;
      this.table.pageSize = 15;
      this.getList(this.searchForm, this.searchType);
    },
    async getList(searchForm, searchType, isExport = false) {
      this.table.loading = true;
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          PageNumber: this.table.pageNum,
          PageSize: this.table.pageSize,
          SearchList: [],
          SortList: [
            {
              SortDescend: true,
              SortProperty: "CreateTime",
            },
          ],
        },
      };
      if (searchType || searchType === 0) {
        obj.Params.SearchList.push({
          CompareType: "Equal",
          PropertyName: "Status",
          PropertyValue: searchType,
        });
      }
      if (searchForm) {
        Object.keys(searchForm).forEach(function (key) {
          if (searchForm[key]) {
            obj.Params.SearchList.push({
              CompareType: "Contains",
              PropertyName: key,
              PropertyValue: searchForm[key],
            });
          }
        });
      }
      const res = await this.$api.axios_http(
        this.$gd.admin.template.getList,
        obj,
        "POST"
      );
      this.table.loading = false;
      if (res.ReturnCode == 0) {
        if (res.ReturnList && res.ReturnList.length > 0) {
          res.ReturnList.forEach((item) => {
            if (item.CreateTime) {
              item.CreateTime = this.$moment(item.CreateTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
            if (item.CheckTime) {
              item.CheckTime = this.$moment(item.CheckTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
            if (item.UpdateTime) {
              item.UpdateTime = this.$moment(item.UpdateTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          });
        }
        this.table.total = res.RecordCount;
        this.table.data = res.ReturnList;
      } else {
        this.$message.error(res.Error);
      }
    },
    async del(ProtocolID) {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          ProtocolID,
        },
      };
      // 删除
      const res = await this.$api.axios_http(
        this.$gd.admin.template.delete,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.getList(this.searchForm);
      } else {
        this.$message.error(res.Error);
      }
    },
    // 审核
    async Check(ProtocolID) {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          ProtocolID,
        },
      };
      const res = await this.$api.axios_http(
        this.$gd.admin.template.ProProtocol,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        this.$message.success("审核成功");
        this.getList(this.searchForm);
      } else {
        this.$message.error(res.Error);
      }
    },
    //data为需要导出的list内容
    exportExcel(data) {
      this.exportList = [];
      let data_title, key_data;

      // 对数据进行处理
      data.forEach((item) => {
        item.IsConnected = item.IsConnected === true ? "在线" : "离线";
        item.Mode =
          item.Mode === 0 ? "调试模式" : item.Mode === 1 ? "正式使用" : "";
        item.CommunicateMode =
          item.CommunicateMode === 1
            ? "以太网"
            : item.CommunicateMode === 2
            ? "4G"
            : "";
      });
      //表头,有多行表头继续往数组添加，记得进行合并
      data_title = [
        [
          "状态",
          "SN码",
          "设备名称",
          "产品型号",
          "通讯方式",
          "项目名称",
          "状态模式",
          "创建时间",
          "创建人",
          "最后更新时间",
          "IMEI",
          "ICCID",
          "版本",
        ],
      ];

      //表格的值组成的数组
      key_data = [
        "IsConnected",
        "DeviceNo",
        "DeviceName",
        "ProductName",
        "CommunicateMode",
        "PrjName",
        "Mode",
        "UpdateTime",
        "UserName",
        "LastOnLineTime",
        "IMEI",
        "ICCID",
        "Ver",
      ];

      //表头样式设置
      let titleStyle = {
        font: {
          bold: true,
          color: { rgb: "FFFFFF" },
          sz: 12,
        },
        fill: {
          fgColor: { rgb: "2C86D1" },
        },
      };
      if (data && data.length > 0) {
        for (let item of data) {
          let exportData = {};
          key_data.forEach((value) => {
            exportData[value] = item[value] ? item[value] : "";
          });
          this.exportList.push(exportData);
        }
      }
      this.sheet = [];
      let sheetData = {
        multiHeader: data_title,
        table: this.exportList,
        //合并单元格：merges:['A1:A2','A3:A4']
        merges: [],
        keys: key_data,
        sheetName: "设备管理",
        //全局样式
        globalStyle: {},
        //单元格样式
        cellStyle: [
          // {
          //     cell: "A1",
          //     font: {
          //         color: { rgb: "744ca4" },
          //     },
          // },
        ],
      };
      //表头长度
      let titleLength = key_data.length;
      //有几行表头
      let headerLength = data_title.length;
      let cellArr = [];
      for (let i = 1; i <= titleLength; i++) {
        for (let j = 1; j <= headerLength; j++) {
          if (i > 26) {
            let num = i - 26;
            let titleNum = Math.floor(i / 26);
            cellArr.push(
              String.fromCharCode(64 + parseInt(titleNum)) +
                String.fromCharCode(64 + parseInt(num)) +
                j
            );
          } else {
            cellArr.push(String.fromCharCode(64 + parseInt(i)) + j);
          }
        }
      }
      //开始设置样式
      cellArr.forEach((item) => {
        sheetData.cellStyle.push({
          cell: item,
          ...titleStyle,
        });
      });

      //表格全局样式
      this.sheet.push(sheetData);
      //手动调用导出
      this.$refs.excelExport.pikaExportExcel();
      this.exportLoading = false;
    },
    async sumbit() {
      this.sumbitLoading = true;
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: { ...this.editForm },
      };
      //添加
      let res;
      if (this.editType === 1) {
        res = await this.$api.axios_http(
          this.$gd.admin.template.add,
          obj,
          "POST"
        );
      } else {
        res = await this.$api.axios_http(
          this.$gd.admin.template.edit,
          obj,
          "POST"
        );
      }
      this.sumbitLoading = false;
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.editFormVisible = false;
        if (this.editType === 1) {
          this.table.pageNum = 1;
          this.table.pageSize = 15;
        }
        this.getList(this.searchForm);
      } else {
        this.$message.error(res.Error);
      }
    },
    getDict(DicID) {
      // 获取数据字典   协议类型
      let obj = {
        Params:{
           DicID:DicID
        }
      };
      return new Promise((resolve) => {
        this.$api.axios_http(this.$gd.GetDict, obj, "POST").then((res) => {
          if (res.ReturnCode == 0) {
            if (res.ReturnList && res.ReturnList.length > 0) {
              this.dictOptions = res.ReturnList;
              // console.log("字典数据", this.dictOptions);
            }
            resolve();
          } else {
            this.$message.error(res.Error);
          }
        });
      });
    },
    getDict1(DicID) {
      // 获取数据字典   规格标识
      let obj = {
         Params:{
           DicID:DicID
        }
      };
      return new Promise((resolve) => {
        this.$api.axios_http(this.$gd.GetDict, obj, "POST").then((res) => {
          if (res.ReturnCode == 0) {
            if (res.ReturnList && res.ReturnList.length > 0) {
              this.Spec = res.ReturnList;
            }
            resolve();
          } else {
            this.$message.error(res.Error);
          }
        });
      });
    },
    async Company() {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          PageNumber: this.table.pageNum,
          PageSize: this.table.pageSize,
          SearchList: [],
          SortList: [
            {
              SortDescend: true,
              SortProperty: "CreateTime",
            },
          ],
        },
      };
      const res = await this.$api.axios_http(
        this.$gd.admin.vender.getList,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        if (res.ReturnList && res.ReturnList.length > 0) {
          let List = [];
          res.ReturnList.forEach((item, index) => {
            List.push({
              CompName: item.CompName,
              CompCode: item.CompCode,
              CompID: item.CompID,
              CompValue: index,
            });
          });
          this.CompanyList = List;
        }
        // this.table.total = res.RecordCount;
        // this.table.data = res.ReturnList;
        // console.log("11111", this.CompanyList);
      } else {
        this.$message.error(res.Error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .toolBox {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    box-sizing: border-box;
  }
  .rightBox {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    padding: 10px;
    padding-top: 0;
  }
}
</style>
